const authHeader = () => {
  const raw = localStorage.getItem("accessToken");

  let tokenString;
  try {
    tokenString = JSON.parse(raw);
  } catch {
    tokenString = raw; // ✅ token is a plain string, use it directly
  }

  return {
    Authorization: tokenString ? `Bearer ${tokenString}` : "",
    "Content-Type": "application/json",
  };
};

export { authHeader };
